var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 350,
    viewBox: "0 0 500 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.597 42.9202C332.597 42.9202 326.018 43.9764 326.018 50.5553C326.018 57.1342 332.597 57.6036 332.597 57.6036",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.14 70.5334V274.051H956.073C956.073 274.051 952.78 215.531 888.627 215.531C888.627 215.531 832.462 214.241 823.763 274.051V299.2H474.191H461.855",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.185 299.193V302.369L461.848 306.131H373.955V268.177C373.955 268.177 375.073 217.299 320.254 192.971C265.434 168.644 193.701 212.715 193.701 212.715L188.234 221.703V244.615L192.293 244.65L233.002 244.968C233.002 244.968 255.914 201.608 308.09 221.876C360.259 242.144 353.742 292.38 353.742 292.38C353.742 292.38 357.325 306.124 373.955 306.124",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.137 248.136H187.536L171.5 253.597V279.685H212.036C212.036 279.691 223.406 261.356 223.137 248.136Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.241 221.703C188.241 221.703 190.974 218.445 205.161 217.471V236.152C205.161 236.152 199.431 240.998 188.241 241.612",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.519 247.08C827.519 247.08 823.818 252.63 822.231 259.948H467.605V247.08H827.519Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.658 253.514H822.231",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.14 212.004H467.606V206.191H1090.14",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.14 178.695H467.606V165.475H1090.14",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.658 172.082H1085.56",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.58 145.38H467.606V155.431H1090.14",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.848 70.5334V306.124",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.525 306.124V70.5334",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.15 306.124V76.6431H390.053V306.124",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.397 84.7476H446.806V293.436H396.397V84.7476Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.069 70.5334H564.197V145.386H476.069V70.5334Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.762 73.4124H560.49V106.017H479.762V73.4124Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.762 110.601H560.49V142.501H479.762V110.601Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.58 66.4192H329.304",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.941 41.7466V61.3107H336.911V41.7466",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.911 61.3107L336.117 64.3067H332.59V40.0966H336.704V41.7396H338.934C343.338 32.3994 351.622 30.1075 351.622 30.1075C377.268 20.0631 464.251 19 464.251 19H1078.16C1094.14 35.7475 1090.14 70.5266 1090.14 70.5266H329.304V56.5404",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.256 73.4124L378.656 86.0455V152.787H335.413L346.459 78.7555H358.677V73.4124H365.256Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.772 150.405H375.363V86.7496L362.025 73.4124",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.458 78.7553L343.994 76.6429H339.997L337.926 79.8116H334.592V70.5334",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.641 151.282H333.211V155.783",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.166 155.783H320.254V192.971C320.254 192.971 307.828 195.353 308.09 221.876",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.253 155.783C320.253 155.783 237.317 165.386 207.708 176.935C207.708 176.935 193.963 179.227 193.701 212.715",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.625 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.865 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.104 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.337 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.577 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.816 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.049 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.289 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.529 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.761 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.001 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.241 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.474 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.713 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.953 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.186 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.425 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.665 173.318V182.133",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.659 349.56C250.539 349.56 223.69 322.711 223.69 289.591C223.69 256.471 250.539 229.621 283.659 229.621C316.779 229.621 343.628 256.471 343.628 289.591C343.628 322.711 316.779 349.56 283.659 349.56Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.659 346.405C252.281 346.405 226.844 320.969 226.844 289.591C226.844 258.213 252.281 232.776 283.659 232.776C315.037 232.776 340.474 258.213 340.474 289.591C340.474 320.969 315.037 346.405 283.659 346.405Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.659 323.431C264.969 323.431 249.819 308.28 249.819 289.591C249.819 270.901 264.969 255.75 283.659 255.75C302.348 255.75 317.499 270.901 317.499 289.591C317.499 308.28 302.348 323.431 283.659 323.431Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.659 321.912C265.808 321.912 251.337 307.441 251.337 289.591C251.337 271.74 265.808 257.269 283.659 257.269C301.51 257.269 315.98 271.74 315.98 289.591C315.98 307.441 301.51 321.912 283.659 321.912Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.659 300.608C277.574 300.608 272.641 295.676 272.641 289.591C272.641 283.506 277.574 278.573 283.659 278.573C289.744 278.573 294.677 283.506 294.677 289.591C294.677 295.676 289.744 300.608 283.659 300.608Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.659 302.7C276.418 302.7 270.549 296.831 270.549 289.591C270.549 282.351 276.418 276.481 283.659 276.481C290.899 276.481 296.768 282.351 296.768 289.591C296.768 296.831 290.899 302.7 283.659 302.7Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.293 248.136V244.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.466 277.234L223.144 291.848",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.742 292.38H343.635",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.414 332.256C347.195 333.037 347.195 334.304 346.414 335.085L333.686 347.813C332.905 348.594 331.639 348.594 330.858 347.813C330.077 347.032 330.077 345.765 330.858 344.984L342.172 333.671L330.858 322.357C330.077 321.576 330.077 320.31 330.858 319.529C331.639 318.747 332.905 318.747 333.686 319.529L346.414 332.256ZM77.5858 335.085C76.8047 334.304 76.8047 333.037 77.5858 332.256L90.3137 319.529C91.0948 318.747 92.3611 318.747 93.1421 319.529C93.9232 320.31 93.9232 321.576 93.1421 322.357L81.8284 333.671L93.1421 344.984C93.9232 345.765 93.9232 347.032 93.1421 347.813C92.3611 348.594 91.0948 348.594 90.3137 347.813L77.5858 335.085ZM345 335.671L79 335.671L79 331.671L345 331.671L345 335.671Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.5 148.171L349.5 349.671",
    stroke: "#2D9DC9",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.187 132.646C338.36 131.555 339.395 130.671 340.5 130.671H362.5C363.605 130.671 364.36 131.555 364.187 132.646L361.997 146.474C361.824 147.565 360.789 148.449 359.684 148.449H337.684C336.58 148.449 335.824 147.565 335.997 146.474L338.187 132.646ZM348.418 147.142H349.367C349.603 147.142 349.825 146.953 349.861 146.72L350.409 143.266C350.445 143.033 350.284 142.844 350.048 142.844H349.099C348.863 142.844 348.641 143.033 348.604 143.266L348.057 146.72C348.02 146.953 348.182 147.142 348.418 147.142ZM351.087 136.281H350.138C349.902 136.281 349.74 136.093 349.778 135.856L350.325 132.401C350.362 132.168 350.583 131.979 350.82 131.979H351.768C352.005 131.979 352.166 132.168 352.129 132.401L351.582 135.86C351.545 136.093 351.323 136.281 351.087 136.281ZM342.689 140.452H346.195C346.431 140.452 346.652 140.263 346.689 140.03L346.837 139.095C346.874 138.862 346.712 138.674 346.476 138.674H342.97C342.734 138.674 342.513 138.862 342.476 139.095L342.328 140.03C342.291 140.263 342.452 140.452 342.689 140.452ZM353.35 140.026L353.498 139.091C353.535 138.858 353.756 138.669 353.993 138.669H357.499C357.735 138.669 357.897 138.858 357.86 139.091L357.712 140.026C357.675 140.258 357.453 140.447 357.217 140.447H353.711C353.475 140.447 353.313 140.258 353.35 140.026ZM343.521 144.591L344.088 145.254C344.231 145.421 344.503 145.421 344.694 145.254L347.563 142.809C347.759 142.642 347.801 142.374 347.657 142.212L347.09 141.549C346.947 141.382 346.675 141.382 346.484 141.549L343.615 143.994C343.424 144.157 343.382 144.424 343.521 144.591ZM353.707 137.572C353.516 137.739 353.244 137.739 353.101 137.572L352.534 136.909C352.39 136.747 352.432 136.479 352.628 136.312L355.497 133.867C355.688 133.701 355.96 133.701 356.103 133.867L356.671 134.53C356.814 134.693 356.772 134.96 356.576 135.127L353.707 137.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67 349.171L539.5 349.171",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 317.15,
    width: 31,
    height: 32,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.131bc96bee17d0453605fd5d080cb6c5.svg";
export { ForwardRef as ReactComponent };